import { Action } from "@omni/ui/components/CallToAction/types/action.types";
import { ActionType } from "@omni/ui/components/CallToAction/types/enums/actionType.enum";
import { PrefetchedData } from "@omni/ui/components/CallToAction/types/prefetchedData.types";
import { PropsWithChildren } from "react";

import { AddToCartButton } from "./AddToCartButton/addToCartButton.container";
import { AdvisorButton } from "./AdvisorButton/advisorButton.container";
import { PrintButton } from "./PrintButton/printButton.container";

type ButtonCallToActionProps = PropsWithChildren<{
    action: Action;
    prefetchedData?: PrefetchedData;
}>;

const ButtonCallToAction = ({
    children,
    action,
    prefetchedData
}: ButtonCallToActionProps) =>
    action.actionType === ActionType.ADD_TO_CART ? (
        <AddToCartButton
            addToCartItems={action.addToCartItems.map((addToCartItem) => ({
                amount: addToCartItem.amount,
                sku: addToCartItem.sku,
                product: prefetchedData?.products?.find(
                    ({ sku }) => sku === addToCartItem.sku
                )
            }))}
        >
            {children}
        </AddToCartButton>
    ) : action.actionType === ActionType.ADVISOR && action.advisorId ? (
        <AdvisorButton
            advisorId={action.advisorId}
            advisorType={action.advisorType}
            advisorMode={action.advisorMode}
        >
            {children}
        </AdvisorButton>
    ) : action.actionType === ActionType.PRINT ? (
        <PrintButton>{children}</PrintButton>
    ) : null;

export { ButtonCallToAction };
